export { default } from 'ember-cli-flash/services/flash-messages';
